import { memo } from 'react';
import {
    CustomSlider,
    Element,
    IconButton,
    Image,
    RouterLink,
    Section,
} from '@zmedia/bm-soccer-ui/components';
import { ITournament } from '@zmedia/bm-soccer-ui/interface';
import { URL_SOCCER_PAGE } from '@zmedia/bm-soccer-ui/modules/shared';
import styles from './style.module.scss';

const SlickButtonFix = ({
    currentSlide,
    slideCount,
    children,
    ...props
}: any) => <span {...props}>{children}</span>;

export function TournamentsHotSection(props: any) {
    const { items = [] } = props;

    const settings = {
        slidesToShow: 1,
        slidesToScroll: 2,
        
        dots: false,
        infinite: true,
        speed: 500,
        variableWidth: true,
        draggable: false,
        swipe: true,
        nextArrow: (
            <SlickButtonFix>
                <IconButton
                    className={styles['btn-next']}
                    icon="forward-2"
                    title="Tiếp theo"
                ></IconButton>
            </SlickButtonFix>
        ),
        prevArrow: (
            <SlickButtonFix>
                <IconButton
                    className={styles['btn-prev']}
                    icon="back-2"
                    title="Trước"
                ></IconButton>
            </SlickButtonFix>
        ),
    };
    return (
        <Section className={styles['tournament-hot-section']}>
            <Element className={styles['tournament-hot-list']}>
                <CustomSlider settings={settings}>
                    {items.map((item: ITournament, index: number) => {
                        return <TournamentHotItem item={item} key={index} />;
                    })}
                </CustomSlider>
            </Element>
        </Section>
    );
}

function TournamentHotItem({ item }: {item: ITournament}) {
    return (
        <RouterLink
            to={`${URL_SOCCER_PAGE.SUBPATH}${item.path}`}
            className={styles['tournament-hot-item']}
            tabIndex={-1}
            title={item.name}
        >
            <Image src={item.logo} alt={'Giải đấu ' + item.name} />
            <Element className={styles['text']}>{item.name}</Element>
        </RouterLink>
    );
}

export default memo(TournamentsHotSection);
